<ng-container *ngIf="this.isActiveAsync | async as isActive">
	<div
		[style.backgroundColor]="this.customBackColor"
		[style.position]="this.fixed ? 'fixed' : 'absolute'"
		@fadeOut
		*ngIf="!!isActive"
		class="app-loader overflow-hidden {{ this.classList }}"
	>
		<div class="loader-wrapper">
			<div
				@fade
				class="loader-content"
			>
				<div class="loader-circle">
					<div *ngIf="this.logo.enabled">
						<div
							[style.height.px]="this.logo.height"
							[style.width.px]="this.logo.width"
							class="loader-logo"
						>
							<img
								[border]="0"
								[ngClass]="{ 'rounded-circle': this.logo.circle, rounded: this.logo.rounded }"
								[src]="this.logo.url | safeUrl"
								[style.height.px]="this.logo.height"
								[style.width.px]="this.logo.width"
								#image
								alt=""
								class="img-responsive"
							>
						</div>
					</div>
					<ng-container *ngIf="this.enableCircle !== false">
						<mat-spinner
							[color]="this.customLoadingColor"
							[diameter]="this.width"
							[mode]="'indeterminate'"
							[strokeWidth]="this.circleStrokeWidth"
						></mat-spinner>
					</ng-container>
					<ng-container *ngIf="this.enableCircle === false">
						<mat-progress-bar
							[color]="this.customLoadingColor"
							[mode]="'indeterminate'"
							[style.width.px]="this.width"
						></mat-progress-bar>
					</ng-container>
					<div
						[innerText]="this.currentStatus"
						*ngIf="this.enableStatus"
						class="text-center mt-3"
						style="width: 200px; max-width: 100%"
					></div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
